module.exports = __webpack_public_path__ + "img/docRes_b.476eec9f.png";